import React, { useContext, useMemo, useState } from 'react'
import { dateCol, intCol, numCol, strCol } from '@integec/grid-tools/lib/cols'
import CommonScreen from '../admin/component/CommonScreen'
import {
  getScheduleDetails,
  // importScheduleDetailsTest,
  updateScheduleDetail,
  deleteScheduleDetail,
  getAuthorization,
  getCredentials,
  importScheduleDetailsAutoImport,
} from '../api/pgads'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnits,
} from 'core'
import { connect } from 'react-redux'
import {
  Button,
  DatePicker,
  Icon,
  Input,
  InputNumber,
  message,
  Upload,
} from 'antd'
import {
  DatePickerContext,
  PNodeZoneContext,
  ErrorContext,
  SpinContext,
  JcTmpErrorContext,
} from 'context'
import {
  modifiedDateCol,
  modifierCol,
  unitIdHeader,
} from 'core/HeaderColTypeProps'
import { Label } from 'core/screen-util'
import MarginAnalysisUtilityUnitSelection from '../marginanalysis/MarginAnalysisUtilityUnitSelection'
import R from 'ramda'
import * as ScreenPermissions from 'core/EventActions'
import { hasAccesPermits } from 'core/utils'
import { CriteriaRow } from '../core/screen-util'

const title = 'Schedule Detail'

const ScheduleDetail = ({ targetInfo, envConfig, actionPermits }) => {
  const { setError } = useContext(ErrorContext)

  const { setSpinning } = useContext(SpinContext)
  const { selectedDate } = useContext(DatePickerContext)
  const { setTmpError } = useContext(JcTmpErrorContext)

  const [insertEvent, setInsertEvent] = useState(false)
  const {
    unitIdEmktIdMap,
    emktIdUnitNameMap,
    // marginUnitsList,
    emktUnits,
  } = useContext(PNodeZoneContext)

  // const manualImport = _ => {
  //   importScheduleDetailsTest(targetInfo).fork(setError, _ => _)
  // }

  const fileProps = {
    name: 'file',
    action: `${targetInfo.baseUrl}/pjm-admin/import-schedule-detail-manual`,
    method: 'POST',
    data: {},
    headers: getAuthorization(targetInfo),
    ...getCredentials(targetInfo),
  }

  const autoIsoImport = _ => {
    setSpinning(true)
    importScheduleDetailsAutoImport(targetInfo)(selectedDate).fork(
      setError,
      tmpError => {
        setSpinning(false)
        setTmpError(tmpError)
      }
    )
  }

  const extraCriteriaAfterButton = () => {
    return (
      <CriteriaRow
        style={{ padding: '0px', paddingBottom: '5px', justifyContent: 'end' }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '150px 150px',
            columnGap: '20px',
            border: '0px solid black',
            padding: '2px',
          }}
        >
          <Upload
            {...fileProps}
            beforeUpload={_ => setSpinning(true)}
            onChange={data => {
              setSpinning(false)
              if (
                data.file.response &&
                data.file.response.restfulStatus &&
                data.file.response.restfulStatus === 'FAILURE'
              ) {
                // setShowMessages(true)
                // setMessages([data.file.response])
                setError(data.file.response)
              } else if (
                data.file.response &&
                data.file.response.length === 0
              ) {
                //  if (data.file.response) {
                message.success('File imported successfully')
                // }
              } else if (data.file.response && data.file.response.length > 0) {
                setTmpError(data.file.response)
                //  if (data.file.response) {
                // message.success('File imported successfully')
                // }
              }
            }}
            multiple={false}
            showUploadList={false}
          >
            <Button disabled={!importPermission} type="primary">
              <Icon type="upload" /> Manual CSV Import
            </Button>
          </Upload>
          <Button
            type="danger"
            onClick={autoIsoImport}
            disabled={!importPermission}
            style={{ marginLeft: '10px' }}
          >
            Auto ISO Import
          </Button>
        </div>
      </CriteriaRow>
    )
  }

  // eslint-disable-next-line no-unused-vars
  const withCriteria = (state, props, selectedUnits) => ({
    // unitid: selectedUnits.map(u => u.unitId).map(id => unitIdEmktIdMap[id]),
    startdate: selectedDate,
    enddate: selectedDate,
  })

  const extraUnitSelectionProps = _ => ({
    limitedUnits: emktUnits,
    units: emktUnits,
    // itemToLabel: e => e.emktId,
  })

  const headerWithFormatter = OaScheduleDetailHeaders.map(header =>
    header.ident === 'unitId' || header.ident === 'unitid'
      ? {
          ...header,
          dataFormatter: ({ value }) => emktIdUnitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            emktIdUnitNameMap[rowData.unitId] ||
            emktIdUnitNameMap[rowData.unitid] ||
            rowData.unitId ||
            rowData.unitid,
        }
      : header
  )

  const headerMap = R.compose(
    R.fromPairs,
    R.map(d => [d.ident, d.display])
  )(OaScheduleDetailHeaders)

  const defaultInsertData = {
    transdate: selectedDate.format('YYYY-MM-DD'),
    transdateObj: selectedDate,
  }

  const importPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.CHANGE_PERMISSIONS],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  return (
    <CommonScreen
      withDatePicker
      headerRowHeight={60}
      extraUnitSelectionProps={extraUnitSelectionProps}
      extraCriteria={extraCriteriaAfterButton}
      withCriteria={withCriteria}
      withUnitSelection={false}
      title={title}
      header={headerWithFormatter}
      retrieveTask={getScheduleDetails}
      deleteTask={deleteScheduleDetail}
      saveTask={updateScheduleDetail}
      defaultInsertData={defaultInsertData}
      altBy={d => d.unitid}
      autoRetrieve={false}
      sortOptions={OaScheduleDetailHeaders}
      widthOffset={100}
      heightOffset={270}
      insertComp={
        insertEvent && importPermission
          ? pr => (
              <ScheduleInsertComponent
                {...pr}
                unitIdEmktIdMap={unitIdEmktIdMap}
                headerMap={headerMap}
              />
            )
          : false
      }
      insertCompHeight={420}
      onInsertEvent={b => setInsertEvent(importPermission && b)}
    />
  )
}

export const ScheduleInsertComponent = ({
  insertData,
  setInsertData,
  onAdd,
  onCancel,
  unitIdEmktIdMap,
  headerMap,
}) => {
  const InputNumberComp = ({ field, disabled = false }) => {
    return (
      <React.Fragment>
        <Label>{headerMap[field]} :</Label>
        <InputNumber
          key={field}
          value={insertData[field]}
          onChange={value => setInsertData({ ...insertData, [field]: value })}
          // onChange={e =>
          //   updateInsertData({ ...insertData, [field]: e.target.value })
          // }
          disabled={disabled}
          style={{ width: '100%' }}
        />
      </React.Fragment>
    )
  }

  const InputComp = ({ field, disabled = false }) => {
    return (
      <React.Fragment>
        <Label>{headerMap[field]} :</Label>
        <Input
          key={field}
          value={insertData[field]}
          onChange={e =>
            setInsertData({ ...insertData, [field]: e.target.value })
          }
          style={{ width: '100%' }}
          // onChange={e =>
          //   updateInsertData({ ...insertData, [field]: e.target.value })
          // }
          disabled={disabled}
        />
      </React.Fragment>
    )
  }

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr',
        gap: '5px',
      }}
    >
      <Label>Unit:</Label>
      <div style={{ gridColumn: 'span 3' }}>
        <MarginAnalysisUtilityUnitSelection
          utility={insertData.utility || null}
          unit={insertData.unit || null}
          onUnitChange={value => {
            // setUtilityUnit(value)
            setInsertData({
              ...insertData,
              utility: value[0],
              unit: value[1],
              unitId: unitIdEmktIdMap[value[1]],
            })
          }}
          style={{ width: '100%' }}
        />
      </div>
      <InputNumberComp field="schedule" />
      <Label>Trans Date:</Label>
      <DatePicker
        allowClear={false}
        format="MM/DD/YYYY"
        value={insertData.transdateObj}
        onChange={date => {
          setInsertData({
            ...insertData,
            transdate: date.format('YYYY-MM-DD'),
            transdateObj: date,
          })
        }}
        style={{ width: '100%', gridColumnEnd: 'span 1' }}
      />
      <InputComp field="market" />
      <InputNumberComp field="ecoMinmw" />
      <InputNumberComp field="ecoMaxmw" />
      <InputNumberComp field="emerMinmw" />
      <InputNumberComp field="emerMaxmw" />
      <InputComp field="useStartupNoload" />

      <InputNumberComp field="noloadCost" />
      <InputNumberComp field="hotstartupCost" />
      <InputNumberComp field="interstartupCost" />
      <InputNumberComp field="coldstartupCost" />

      <InputComp field="primaryFuel" />
      <InputComp field="subFuel" />
      <InputNumberComp field="minRuntime" />
      <InputNumberComp field="maxRuntime" />
      <InputNumberComp field="minDowntime" />
      <InputNumberComp field="hottocoldTime" />
      <InputNumberComp field="hottointerTime" />
      <InputNumberComp field="coldstartupTime" />
      <InputNumberComp field="interstartupTime" />
      <InputNumberComp field="hotstartupTime" />
      <InputNumberComp field="coldnotifTime" />
      <InputNumberComp field="internotifTime" />
      <InputNumberComp field="hotnotifTime" />
      <InputNumberComp field="maxdailyStarts" />
      <InputNumberComp field="maxweeklyStarts" />
      <InputNumberComp field="maxdailyEnergy" />
      <InputNumberComp field="maxweeklyEnergy" />

      <Button type="primary" onClick={() => onAdd(true)}>
        Add
      </Button>
      <Button type="primary" onClick={() => onAdd(false)}>
        Add & Hide
      </Button>
      <Button type="danger" onClick={onCancel}>
        Cancel
      </Button>
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  units: getUnits(state),
})

export default connect(mapStateToProps)(ScheduleDetail)

export const OaScheduleDetailHeaders = [
  // strCol({ ident: 'companyId', display: 'CompanyId', isFiltered: true }),
  unitIdHeader,
  // strCol({ ident: 'unitId', display: 'Unitid', isKey: true }),

  dateCol({
    ident: 'transdate',
    display: 'Transdate',
    isKey: true,
    sortOrder: 'asc',
  }),
  intCol({
    ident: 'schedule',
    display: 'Schedule',
    isKey: true,
    sortOrder: 'asc',
  }),
  strCol({ ident: 'market', display: 'Market', isKey: true, sortOrder: 'asc' }),
  numCol({
    ident: 'ecoMinmw',
    display: 'Eco Min MW',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'ecoMaxmw',
    display: 'Eco Max MW',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({ ident: 'emerMinmw', display: 'Emer Min MW', isFiltered: true }),
  numCol({ ident: 'emerMaxmw', display: 'Emer Max MW', isFiltered: true }),
  strCol({
    ident: 'useStartupNoload',
    display: 'Use Startup Noload',
    isFiltered: true,
  }),
  numCol({ ident: 'noloadCost', display: 'Noload Cost ($)', isFiltered: true }),
  numCol({
    ident: 'hotstartupCost',
    display: 'Hot Startup Cost ($)',
    isFiltered: true,
  }),
  numCol({
    ident: 'interstartupCost',
    display: 'Inter Startup Cost ($)',
    isFiltered: true,
  }),
  numCol({
    ident: 'coldstartupCost',
    display: 'Cold Startup Cost ($)',
    isFiltered: true,
  }),
  strCol({ ident: 'primaryFuel', display: 'Primary Fuel', isFiltered: true }),
  strCol({ ident: 'subFuel', display: 'Sub Fuel', isFiltered: true }),
  numCol({ ident: 'minRuntime', display: 'Min Run Time', isFiltered: true }),
  numCol({ ident: 'maxRuntime', display: 'Max Run Time', isFiltered: true }),
  numCol({ ident: 'minDowntime', display: 'Min Down Time', isFiltered: true }),
  numCol({
    ident: 'hottocoldTime',
    display: 'Hot to Cold Time',
    isFiltered: true,
  }),
  numCol({
    ident: 'hottointerTime',
    display: 'Hot to Inter Time',
    isFiltered: true,
  }),
  numCol({
    ident: 'coldstartupTime',
    display: 'Cold Startup Time',
    isFiltered: true,
  }),
  numCol({
    ident: 'interstartupTime',
    display: 'Inter Startup Time',
    isFiltered: true,
  }),
  numCol({
    ident: 'hotstartupTime',
    display: 'Hot Startup Time',
    isFiltered: true,
  }),
  numCol({
    ident: 'coldnotifTime',
    display: 'Cold Notif Time',
    isFiltered: true,
  }),
  numCol({
    ident: 'internotifTime',
    display: 'Inter Notif Time',
    isFiltered: true,
  }),
  numCol({
    ident: 'hotnotifTime',
    display: 'Hot not if Time',
    isFiltered: true,
  }),
  numCol({
    ident: 'maxdailyStarts',
    display: 'Max Daily Starts',
    isFiltered: true,
  }),
  numCol({
    ident: 'maxweeklyStarts',
    display: 'Max Weekly Starts',
    isFiltered: true,
  }),
  numCol({
    ident: 'maxdailyEnergy',
    display: 'Max Daily Energy',
    isFiltered: true,
  }),
  numCol({
    ident: 'maxweeklyEnergy',
    display: 'Max Weekly Energy',
    isFiltered: true,
  }),
  modifierCol,
  modifiedDateCol,
]
